import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from, palette, space, textSans17, until, } from '@guardian/source/foundations';
import { Column, Columns, Container } from '@guardian/source/react-components';
import { PageScaffold } from 'components/page/pageScaffold';
import { SecureTransactionIndicator } from 'components/secureTransactionIndicator/secureTransactionIndicator';
import ObserverFooter from './ObserverFooter';
import ObserverHeader from './ObserverHeader';
import { observerColours } from './styles';
const secureTransactionIndicator = css `
	margin-bottom: ${space[3]}px;
	${from.tablet} {
		margin-bottom: ${space[4]}px;
	}
`;
const darkBackgroundContainerMobile = css `
	display: flex;
	background-color: ${observerColours.pageBackgroundColor};
	${until.tablet} {
		border-bottom: 1px solid ${palette.brand[600]};
	}
`;
const noBordersContainerMobileStyles = css `
	${until.tablet} {
		background-color: ${palette.neutral[100]};
	}
`;
const topBorder = css `
	border-top: 1px solid ${palette.neutral[86]};
	padding-top: ${space[2]}px;
`;
const columns = css `
	position: relative;
	color: ${palette.neutral[7]};
	${textSans17};
	padding-top: ${space[2]}px;
`;
export default function ObserverPageLayout({ children, borderBox = false, }) {
    return (_jsx(PageScaffold, { header: _jsx(ObserverHeader, {}), footer: _jsx(ObserverFooter, {}), children: borderBox ? (_jsx(Container, { sideBorders: true, topBorder: true, cssOverrides: darkBackgroundContainerMobile, children: _jsxs(Columns, { cssOverrides: columns, collapseUntil: "tablet", children: [_jsx(Column, { span: [0, 2, 2, 3, 4] }), _jsxs(Column, { span: [1, 8, 8, 8, 8], children: [_jsx(SecureTransactionIndicator, { align: "center", theme: "dark", cssOverrides: secureTransactionIndicator }), children] })] }) })) : (_jsx(Container, { cssOverrides: [
                darkBackgroundContainerMobile,
                noBordersContainerMobileStyles,
                topBorder,
            ], children: children })) }));
}
